import {
  WorkflowNodeData,
  WorkflowNodeTypes,
  SettingParamTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const formNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.FORM,
  data: {
    type: WorkflowNodeTypes.FORM,
    settingsTitle: "Form Settings",
    description: "This is the form node",
    onChange: () => {
      console.log("Start node changed");
    },
    settings: [],
  },
  position: {x: 0, y: 0},
};
